/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authLayoutRouteImport } from './routes/(auth)/layout'
import { Route as appLayoutRouteImport } from './routes/(app)/layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StartIndexRouteImport } from './routes/start/index'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as appSettingsIndexRouteImport } from './routes/(app)/settings/index'
import { Route as appProfileIndexRouteImport } from './routes/(app)/profile/index'
import { Route as appOwnerIndexRouteImport } from './routes/(app)/owner/index'
import { Route as appIntegrationsIndexRouteImport } from './routes/(app)/integrations/index'
import { Route as appEmployeeIndexRouteImport } from './routes/(app)/employee/index'
import { Route as appCompanyIndexRouteImport } from './routes/(app)/company/index'
import { Route as appCompanyDocumentsRouteImport } from './routes/(app)/company/documents'
import { Route as appCompanyAnnounceRouteImport } from './routes/(app)/company/announce'
import { Route as appProductivityChatsLayoutRouteImport } from './routes/(app)/productivity/chats/layout'
import { Route as appProductivityTodayIndexRouteImport } from './routes/(app)/productivity/today/index'
import { Route as appProductivityTasksIndexRouteImport } from './routes/(app)/productivity/tasks/index'
import { Route as appProductivityNotesIndexRouteImport } from './routes/(app)/productivity/notes/index'
import { Route as appProductivityMyDriveIndexRouteImport } from './routes/(app)/productivity/my-drive/index'
import { Route as appProductivityMeetingsIndexRouteImport } from './routes/(app)/productivity/meetings/index'
import { Route as appProductivityChatsIndexRouteImport } from './routes/(app)/productivity/chats/index'
import { Route as appOwnerOverviewIndexRouteImport } from './routes/(app)/owner/overview/index'
import { Route as appEmployeeTrackingIndexRouteImport } from './routes/(app)/employee/tracking/index'
import { Route as appEmployeeSalaryIndexRouteImport } from './routes/(app)/employee/salary/index'
import { Route as appEmployeeRequestsIndexRouteImport } from './routes/(app)/employee/requests/index'
import { Route as appEmployeeProfileIndexRouteImport } from './routes/(app)/employee/profile/index'
import { Route as appEmployeeLocationIndexRouteImport } from './routes/(app)/employee/location/index'
import { Route as appEmployeeLeaveIndexRouteImport } from './routes/(app)/employee/leave/index'
import { Route as appEmployeeHandbookIndexRouteImport } from './routes/(app)/employee/handbook/index'
import { Route as appEmployeeExpenseLedgerIndexRouteImport } from './routes/(app)/employee/expense-ledger/index'
import { Route as appEmployeeDashboardIndexRouteImport } from './routes/(app)/employee/dashboard/index'
import { Route as appEmployeeAttendanceIndexRouteImport } from './routes/(app)/employee/attendance/index'
import { Route as appCompanyTrackingIndexRouteImport } from './routes/(app)/company/tracking/index'
import { Route as appCompanyTasksIndexRouteImport } from './routes/(app)/company/tasks/index'
import { Route as appCompanySalaryIndexRouteImport } from './routes/(app)/company/salary/index'
import { Route as appCompanyReportsIndexRouteImport } from './routes/(app)/company/reports/index'
import { Route as appCompanyPerformanceReviewIndexRouteImport } from './routes/(app)/company/performance-review/index'
import { Route as appCompanyPaymentsIndexRouteImport } from './routes/(app)/company/payments/index'
import { Route as appCompanyLeaveIndexRouteImport } from './routes/(app)/company/leave/index'
import { Route as appCompanyHolidaysIndexRouteImport } from './routes/(app)/company/holidays/index'
import { Route as appCompanyEmployeesIndexRouteImport } from './routes/(app)/company/employees/index'
import { Route as appCompanyDashboardIndexRouteImport } from './routes/(app)/company/dashboard/index'
import { Route as appCompanyClientsIndexRouteImport } from './routes/(app)/company/clients/index'
import { Route as appCompanyAttendanceIndexRouteImport } from './routes/(app)/company/attendance/index'
import { Route as appCompanyApprovalsIndexRouteImport } from './routes/(app)/company/approvals/index'
import { Route as appProductivityChatsCallsRouteImport } from './routes/(app)/productivity/chats/calls'
import { Route as appProductivityChatsThreadIdRouteImport } from './routes/(app)/productivity/chats/$threadId'
import { Route as appCompanyTrackingEmployeeIdRouteImport } from './routes/(app)/company/tracking/$employeeId'
import { Route as appCompanySalaryEmployeeIdRouteImport } from './routes/(app)/company/salary/$employeeId'
import { Route as appCompanyPerformanceReviewEmployeeIdRouteImport } from './routes/(app)/company/performance-review/$employeeId'
import { Route as appCompanyPaymentsVendorRegisterRouteImport } from './routes/(app)/company/payments/vendor-register'
import { Route as appCompanyPaymentsVendorRouteImport } from './routes/(app)/company/payments/vendor'
import { Route as appCompanyPaymentsSettlementsRouteImport } from './routes/(app)/company/payments/settlements'
import { Route as appCompanyPaymentsEmployeeRouteImport } from './routes/(app)/company/payments/employee'
import { Route as appCompanyLeaveEmployeeIdRouteImport } from './routes/(app)/company/leave/$employeeId'
import { Route as appCompanyEmployeesEmployeeIdRouteImport } from './routes/(app)/company/employees/$employeeId'
import { Route as appCompanyClientsClientIdRouteImport } from './routes/(app)/company/clients/$clientId'
import { Route as appCompanyAttendanceEmployeeIdRouteImport } from './routes/(app)/company/attendance/$employeeId'
import { Route as appCompanyReportsAttendanceIndexRouteImport } from './routes/(app)/company/reports/attendance/index'
import { Route as appCompanyReportsAprovalsIndexRouteImport } from './routes/(app)/company/reports/aprovals/index'
import { Route as appCompanyReportsTallyReportRouteImport } from './routes/(app)/company/reports/tally.$report'

const authLayoutRoute = authLayoutRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const appLayoutRoute = appLayoutRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StartIndexRoute = StartIndexRouteImport.update({
  id: '/start/',
  path: '/start/',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authLayoutRoute,
} as any)
const appSettingsIndexRoute = appSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appProfileIndexRoute = appProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appOwnerIndexRoute = appOwnerIndexRouteImport.update({
  id: '/owner/',
  path: '/owner/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appIntegrationsIndexRoute = appIntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appEmployeeIndexRoute = appEmployeeIndexRouteImport.update({
  id: '/employee/',
  path: '/employee/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyIndexRoute = appCompanyIndexRouteImport.update({
  id: '/company/',
  path: '/company/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyDocumentsRoute = appCompanyDocumentsRouteImport.update({
  id: '/company/documents',
  path: '/company/documents',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyAnnounceRoute = appCompanyAnnounceRouteImport.update({
  id: '/company/announce',
  path: '/company/announce',
  getParentRoute: () => appLayoutRoute,
} as any)
const appProductivityChatsLayoutRoute =
  appProductivityChatsLayoutRouteImport.update({
    id: '/productivity/chats',
    path: '/productivity/chats',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityTodayIndexRoute =
  appProductivityTodayIndexRouteImport.update({
    id: '/productivity/today/',
    path: '/productivity/today/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityTasksIndexRoute =
  appProductivityTasksIndexRouteImport.update({
    id: '/productivity/tasks/',
    path: '/productivity/tasks/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityNotesIndexRoute =
  appProductivityNotesIndexRouteImport.update({
    id: '/productivity/notes/',
    path: '/productivity/notes/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityMyDriveIndexRoute =
  appProductivityMyDriveIndexRouteImport.update({
    id: '/productivity/my-drive/',
    path: '/productivity/my-drive/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityMeetingsIndexRoute =
  appProductivityMeetingsIndexRouteImport.update({
    id: '/productivity/meetings/',
    path: '/productivity/meetings/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityChatsIndexRoute =
  appProductivityChatsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appProductivityChatsLayoutRoute,
  } as any)
const appOwnerOverviewIndexRoute = appOwnerOverviewIndexRouteImport.update({
  id: '/owner/overview/',
  path: '/owner/overview/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appEmployeeTrackingIndexRoute =
  appEmployeeTrackingIndexRouteImport.update({
    id: '/employee/tracking/',
    path: '/employee/tracking/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appEmployeeSalaryIndexRoute = appEmployeeSalaryIndexRouteImport.update({
  id: '/employee/salary/',
  path: '/employee/salary/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appEmployeeRequestsIndexRoute =
  appEmployeeRequestsIndexRouteImport.update({
    id: '/employee/requests/',
    path: '/employee/requests/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appEmployeeProfileIndexRoute = appEmployeeProfileIndexRouteImport.update({
  id: '/employee/profile/',
  path: '/employee/profile/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appEmployeeLocationIndexRoute =
  appEmployeeLocationIndexRouteImport.update({
    id: '/employee/location/',
    path: '/employee/location/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appEmployeeLeaveIndexRoute = appEmployeeLeaveIndexRouteImport.update({
  id: '/employee/leave/',
  path: '/employee/leave/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appEmployeeHandbookIndexRoute =
  appEmployeeHandbookIndexRouteImport.update({
    id: '/employee/handbook/',
    path: '/employee/handbook/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appEmployeeExpenseLedgerIndexRoute =
  appEmployeeExpenseLedgerIndexRouteImport.update({
    id: '/employee/expense-ledger/',
    path: '/employee/expense-ledger/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appEmployeeDashboardIndexRoute =
  appEmployeeDashboardIndexRouteImport.update({
    id: '/employee/dashboard/',
    path: '/employee/dashboard/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appEmployeeAttendanceIndexRoute =
  appEmployeeAttendanceIndexRouteImport.update({
    id: '/employee/attendance/',
    path: '/employee/attendance/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyTrackingIndexRoute = appCompanyTrackingIndexRouteImport.update({
  id: '/company/tracking/',
  path: '/company/tracking/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyTasksIndexRoute = appCompanyTasksIndexRouteImport.update({
  id: '/company/tasks/',
  path: '/company/tasks/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanySalaryIndexRoute = appCompanySalaryIndexRouteImport.update({
  id: '/company/salary/',
  path: '/company/salary/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyReportsIndexRoute = appCompanyReportsIndexRouteImport.update({
  id: '/company/reports/',
  path: '/company/reports/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyPerformanceReviewIndexRoute =
  appCompanyPerformanceReviewIndexRouteImport.update({
    id: '/company/performance-review/',
    path: '/company/performance-review/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyPaymentsIndexRoute = appCompanyPaymentsIndexRouteImport.update({
  id: '/company/payments/',
  path: '/company/payments/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyLeaveIndexRoute = appCompanyLeaveIndexRouteImport.update({
  id: '/company/leave/',
  path: '/company/leave/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyHolidaysIndexRoute = appCompanyHolidaysIndexRouteImport.update({
  id: '/company/holidays/',
  path: '/company/holidays/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyEmployeesIndexRoute =
  appCompanyEmployeesIndexRouteImport.update({
    id: '/company/employees/',
    path: '/company/employees/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyDashboardIndexRoute =
  appCompanyDashboardIndexRouteImport.update({
    id: '/company/dashboard/',
    path: '/company/dashboard/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyClientsIndexRoute = appCompanyClientsIndexRouteImport.update({
  id: '/company/clients/',
  path: '/company/clients/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCompanyAttendanceIndexRoute =
  appCompanyAttendanceIndexRouteImport.update({
    id: '/company/attendance/',
    path: '/company/attendance/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyApprovalsIndexRoute =
  appCompanyApprovalsIndexRouteImport.update({
    id: '/company/approvals/',
    path: '/company/approvals/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appProductivityChatsCallsRoute =
  appProductivityChatsCallsRouteImport.update({
    id: '/calls',
    path: '/calls',
    getParentRoute: () => appProductivityChatsLayoutRoute,
  } as any)
const appProductivityChatsThreadIdRoute =
  appProductivityChatsThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => appProductivityChatsLayoutRoute,
  } as any)
const appCompanyTrackingEmployeeIdRoute =
  appCompanyTrackingEmployeeIdRouteImport.update({
    id: '/company/tracking/$employeeId',
    path: '/company/tracking/$employeeId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanySalaryEmployeeIdRoute =
  appCompanySalaryEmployeeIdRouteImport.update({
    id: '/company/salary/$employeeId',
    path: '/company/salary/$employeeId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyPerformanceReviewEmployeeIdRoute =
  appCompanyPerformanceReviewEmployeeIdRouteImport.update({
    id: '/company/performance-review/$employeeId',
    path: '/company/performance-review/$employeeId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyPaymentsVendorRegisterRoute =
  appCompanyPaymentsVendorRegisterRouteImport.update({
    id: '/company/payments/vendor-register',
    path: '/company/payments/vendor-register',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyPaymentsVendorRoute =
  appCompanyPaymentsVendorRouteImport.update({
    id: '/company/payments/vendor',
    path: '/company/payments/vendor',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyPaymentsSettlementsRoute =
  appCompanyPaymentsSettlementsRouteImport.update({
    id: '/company/payments/settlements',
    path: '/company/payments/settlements',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyPaymentsEmployeeRoute =
  appCompanyPaymentsEmployeeRouteImport.update({
    id: '/company/payments/employee',
    path: '/company/payments/employee',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyLeaveEmployeeIdRoute =
  appCompanyLeaveEmployeeIdRouteImport.update({
    id: '/company/leave/$employeeId',
    path: '/company/leave/$employeeId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyEmployeesEmployeeIdRoute =
  appCompanyEmployeesEmployeeIdRouteImport.update({
    id: '/company/employees/$employeeId',
    path: '/company/employees/$employeeId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyClientsClientIdRoute =
  appCompanyClientsClientIdRouteImport.update({
    id: '/company/clients/$clientId',
    path: '/company/clients/$clientId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyAttendanceEmployeeIdRoute =
  appCompanyAttendanceEmployeeIdRouteImport.update({
    id: '/company/attendance/$employeeId',
    path: '/company/attendance/$employeeId',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyReportsAttendanceIndexRoute =
  appCompanyReportsAttendanceIndexRouteImport.update({
    id: '/company/reports/attendance/',
    path: '/company/reports/attendance/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyReportsAprovalsIndexRoute =
  appCompanyReportsAprovalsIndexRouteImport.update({
    id: '/company/reports/aprovals/',
    path: '/company/reports/aprovals/',
    getParentRoute: () => appLayoutRoute,
  } as any)
const appCompanyReportsTallyReportRoute =
  appCompanyReportsTallyReportRouteImport.update({
    id: '/company/reports/tally/$report',
    path: '/company/reports/tally/$report',
    getParentRoute: () => appLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof authLoginRoute
  '/start': typeof StartIndexRoute
  '/productivity/chats': typeof appProductivityChatsLayoutRouteWithChildren
  '/company/announce': typeof appCompanyAnnounceRoute
  '/company/documents': typeof appCompanyDocumentsRoute
  '/company': typeof appCompanyIndexRoute
  '/employee': typeof appEmployeeIndexRoute
  '/integrations': typeof appIntegrationsIndexRoute
  '/owner': typeof appOwnerIndexRoute
  '/profile': typeof appProfileIndexRoute
  '/settings': typeof appSettingsIndexRoute
  '/company/attendance/$employeeId': typeof appCompanyAttendanceEmployeeIdRoute
  '/company/clients/$clientId': typeof appCompanyClientsClientIdRoute
  '/company/employees/$employeeId': typeof appCompanyEmployeesEmployeeIdRoute
  '/company/leave/$employeeId': typeof appCompanyLeaveEmployeeIdRoute
  '/company/payments/employee': typeof appCompanyPaymentsEmployeeRoute
  '/company/payments/settlements': typeof appCompanyPaymentsSettlementsRoute
  '/company/payments/vendor': typeof appCompanyPaymentsVendorRoute
  '/company/payments/vendor-register': typeof appCompanyPaymentsVendorRegisterRoute
  '/company/performance-review/$employeeId': typeof appCompanyPerformanceReviewEmployeeIdRoute
  '/company/salary/$employeeId': typeof appCompanySalaryEmployeeIdRoute
  '/company/tracking/$employeeId': typeof appCompanyTrackingEmployeeIdRoute
  '/productivity/chats/$threadId': typeof appProductivityChatsThreadIdRoute
  '/productivity/chats/calls': typeof appProductivityChatsCallsRoute
  '/company/approvals': typeof appCompanyApprovalsIndexRoute
  '/company/attendance': typeof appCompanyAttendanceIndexRoute
  '/company/clients': typeof appCompanyClientsIndexRoute
  '/company/dashboard': typeof appCompanyDashboardIndexRoute
  '/company/employees': typeof appCompanyEmployeesIndexRoute
  '/company/holidays': typeof appCompanyHolidaysIndexRoute
  '/company/leave': typeof appCompanyLeaveIndexRoute
  '/company/payments': typeof appCompanyPaymentsIndexRoute
  '/company/performance-review': typeof appCompanyPerformanceReviewIndexRoute
  '/company/reports': typeof appCompanyReportsIndexRoute
  '/company/salary': typeof appCompanySalaryIndexRoute
  '/company/tasks': typeof appCompanyTasksIndexRoute
  '/company/tracking': typeof appCompanyTrackingIndexRoute
  '/employee/attendance': typeof appEmployeeAttendanceIndexRoute
  '/employee/dashboard': typeof appEmployeeDashboardIndexRoute
  '/employee/expense-ledger': typeof appEmployeeExpenseLedgerIndexRoute
  '/employee/handbook': typeof appEmployeeHandbookIndexRoute
  '/employee/leave': typeof appEmployeeLeaveIndexRoute
  '/employee/location': typeof appEmployeeLocationIndexRoute
  '/employee/profile': typeof appEmployeeProfileIndexRoute
  '/employee/requests': typeof appEmployeeRequestsIndexRoute
  '/employee/salary': typeof appEmployeeSalaryIndexRoute
  '/employee/tracking': typeof appEmployeeTrackingIndexRoute
  '/owner/overview': typeof appOwnerOverviewIndexRoute
  '/productivity/chats/': typeof appProductivityChatsIndexRoute
  '/productivity/meetings': typeof appProductivityMeetingsIndexRoute
  '/productivity/my-drive': typeof appProductivityMyDriveIndexRoute
  '/productivity/notes': typeof appProductivityNotesIndexRoute
  '/productivity/tasks': typeof appProductivityTasksIndexRoute
  '/productivity/today': typeof appProductivityTodayIndexRoute
  '/company/reports/tally/$report': typeof appCompanyReportsTallyReportRoute
  '/company/reports/aprovals': typeof appCompanyReportsAprovalsIndexRoute
  '/company/reports/attendance': typeof appCompanyReportsAttendanceIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof authLoginRoute
  '/start': typeof StartIndexRoute
  '/company/announce': typeof appCompanyAnnounceRoute
  '/company/documents': typeof appCompanyDocumentsRoute
  '/company': typeof appCompanyIndexRoute
  '/employee': typeof appEmployeeIndexRoute
  '/integrations': typeof appIntegrationsIndexRoute
  '/owner': typeof appOwnerIndexRoute
  '/profile': typeof appProfileIndexRoute
  '/settings': typeof appSettingsIndexRoute
  '/company/attendance/$employeeId': typeof appCompanyAttendanceEmployeeIdRoute
  '/company/clients/$clientId': typeof appCompanyClientsClientIdRoute
  '/company/employees/$employeeId': typeof appCompanyEmployeesEmployeeIdRoute
  '/company/leave/$employeeId': typeof appCompanyLeaveEmployeeIdRoute
  '/company/payments/employee': typeof appCompanyPaymentsEmployeeRoute
  '/company/payments/settlements': typeof appCompanyPaymentsSettlementsRoute
  '/company/payments/vendor': typeof appCompanyPaymentsVendorRoute
  '/company/payments/vendor-register': typeof appCompanyPaymentsVendorRegisterRoute
  '/company/performance-review/$employeeId': typeof appCompanyPerformanceReviewEmployeeIdRoute
  '/company/salary/$employeeId': typeof appCompanySalaryEmployeeIdRoute
  '/company/tracking/$employeeId': typeof appCompanyTrackingEmployeeIdRoute
  '/productivity/chats/$threadId': typeof appProductivityChatsThreadIdRoute
  '/productivity/chats/calls': typeof appProductivityChatsCallsRoute
  '/company/approvals': typeof appCompanyApprovalsIndexRoute
  '/company/attendance': typeof appCompanyAttendanceIndexRoute
  '/company/clients': typeof appCompanyClientsIndexRoute
  '/company/dashboard': typeof appCompanyDashboardIndexRoute
  '/company/employees': typeof appCompanyEmployeesIndexRoute
  '/company/holidays': typeof appCompanyHolidaysIndexRoute
  '/company/leave': typeof appCompanyLeaveIndexRoute
  '/company/payments': typeof appCompanyPaymentsIndexRoute
  '/company/performance-review': typeof appCompanyPerformanceReviewIndexRoute
  '/company/reports': typeof appCompanyReportsIndexRoute
  '/company/salary': typeof appCompanySalaryIndexRoute
  '/company/tasks': typeof appCompanyTasksIndexRoute
  '/company/tracking': typeof appCompanyTrackingIndexRoute
  '/employee/attendance': typeof appEmployeeAttendanceIndexRoute
  '/employee/dashboard': typeof appEmployeeDashboardIndexRoute
  '/employee/expense-ledger': typeof appEmployeeExpenseLedgerIndexRoute
  '/employee/handbook': typeof appEmployeeHandbookIndexRoute
  '/employee/leave': typeof appEmployeeLeaveIndexRoute
  '/employee/location': typeof appEmployeeLocationIndexRoute
  '/employee/profile': typeof appEmployeeProfileIndexRoute
  '/employee/requests': typeof appEmployeeRequestsIndexRoute
  '/employee/salary': typeof appEmployeeSalaryIndexRoute
  '/employee/tracking': typeof appEmployeeTrackingIndexRoute
  '/owner/overview': typeof appOwnerOverviewIndexRoute
  '/productivity/chats': typeof appProductivityChatsIndexRoute
  '/productivity/meetings': typeof appProductivityMeetingsIndexRoute
  '/productivity/my-drive': typeof appProductivityMyDriveIndexRoute
  '/productivity/notes': typeof appProductivityNotesIndexRoute
  '/productivity/tasks': typeof appProductivityTasksIndexRoute
  '/productivity/today': typeof appProductivityTodayIndexRoute
  '/company/reports/tally/$report': typeof appCompanyReportsTallyReportRoute
  '/company/reports/aprovals': typeof appCompanyReportsAprovalsIndexRoute
  '/company/reports/attendance': typeof appCompanyReportsAttendanceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)': typeof appLayoutRouteWithChildren
  '/(auth)': typeof authLayoutRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/start/': typeof StartIndexRoute
  '/(app)/productivity/chats': typeof appProductivityChatsLayoutRouteWithChildren
  '/(app)/company/announce': typeof appCompanyAnnounceRoute
  '/(app)/company/documents': typeof appCompanyDocumentsRoute
  '/(app)/company/': typeof appCompanyIndexRoute
  '/(app)/employee/': typeof appEmployeeIndexRoute
  '/(app)/integrations/': typeof appIntegrationsIndexRoute
  '/(app)/owner/': typeof appOwnerIndexRoute
  '/(app)/profile/': typeof appProfileIndexRoute
  '/(app)/settings/': typeof appSettingsIndexRoute
  '/(app)/company/attendance/$employeeId': typeof appCompanyAttendanceEmployeeIdRoute
  '/(app)/company/clients/$clientId': typeof appCompanyClientsClientIdRoute
  '/(app)/company/employees/$employeeId': typeof appCompanyEmployeesEmployeeIdRoute
  '/(app)/company/leave/$employeeId': typeof appCompanyLeaveEmployeeIdRoute
  '/(app)/company/payments/employee': typeof appCompanyPaymentsEmployeeRoute
  '/(app)/company/payments/settlements': typeof appCompanyPaymentsSettlementsRoute
  '/(app)/company/payments/vendor': typeof appCompanyPaymentsVendorRoute
  '/(app)/company/payments/vendor-register': typeof appCompanyPaymentsVendorRegisterRoute
  '/(app)/company/performance-review/$employeeId': typeof appCompanyPerformanceReviewEmployeeIdRoute
  '/(app)/company/salary/$employeeId': typeof appCompanySalaryEmployeeIdRoute
  '/(app)/company/tracking/$employeeId': typeof appCompanyTrackingEmployeeIdRoute
  '/(app)/productivity/chats/$threadId': typeof appProductivityChatsThreadIdRoute
  '/(app)/productivity/chats/calls': typeof appProductivityChatsCallsRoute
  '/(app)/company/approvals/': typeof appCompanyApprovalsIndexRoute
  '/(app)/company/attendance/': typeof appCompanyAttendanceIndexRoute
  '/(app)/company/clients/': typeof appCompanyClientsIndexRoute
  '/(app)/company/dashboard/': typeof appCompanyDashboardIndexRoute
  '/(app)/company/employees/': typeof appCompanyEmployeesIndexRoute
  '/(app)/company/holidays/': typeof appCompanyHolidaysIndexRoute
  '/(app)/company/leave/': typeof appCompanyLeaveIndexRoute
  '/(app)/company/payments/': typeof appCompanyPaymentsIndexRoute
  '/(app)/company/performance-review/': typeof appCompanyPerformanceReviewIndexRoute
  '/(app)/company/reports/': typeof appCompanyReportsIndexRoute
  '/(app)/company/salary/': typeof appCompanySalaryIndexRoute
  '/(app)/company/tasks/': typeof appCompanyTasksIndexRoute
  '/(app)/company/tracking/': typeof appCompanyTrackingIndexRoute
  '/(app)/employee/attendance/': typeof appEmployeeAttendanceIndexRoute
  '/(app)/employee/dashboard/': typeof appEmployeeDashboardIndexRoute
  '/(app)/employee/expense-ledger/': typeof appEmployeeExpenseLedgerIndexRoute
  '/(app)/employee/handbook/': typeof appEmployeeHandbookIndexRoute
  '/(app)/employee/leave/': typeof appEmployeeLeaveIndexRoute
  '/(app)/employee/location/': typeof appEmployeeLocationIndexRoute
  '/(app)/employee/profile/': typeof appEmployeeProfileIndexRoute
  '/(app)/employee/requests/': typeof appEmployeeRequestsIndexRoute
  '/(app)/employee/salary/': typeof appEmployeeSalaryIndexRoute
  '/(app)/employee/tracking/': typeof appEmployeeTrackingIndexRoute
  '/(app)/owner/overview/': typeof appOwnerOverviewIndexRoute
  '/(app)/productivity/chats/': typeof appProductivityChatsIndexRoute
  '/(app)/productivity/meetings/': typeof appProductivityMeetingsIndexRoute
  '/(app)/productivity/my-drive/': typeof appProductivityMyDriveIndexRoute
  '/(app)/productivity/notes/': typeof appProductivityNotesIndexRoute
  '/(app)/productivity/tasks/': typeof appProductivityTasksIndexRoute
  '/(app)/productivity/today/': typeof appProductivityTodayIndexRoute
  '/(app)/company/reports/tally/$report': typeof appCompanyReportsTallyReportRoute
  '/(app)/company/reports/aprovals/': typeof appCompanyReportsAprovalsIndexRoute
  '/(app)/company/reports/attendance/': typeof appCompanyReportsAttendanceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/start'
    | '/productivity/chats'
    | '/company/announce'
    | '/company/documents'
    | '/company'
    | '/employee'
    | '/integrations'
    | '/owner'
    | '/profile'
    | '/settings'
    | '/company/attendance/$employeeId'
    | '/company/clients/$clientId'
    | '/company/employees/$employeeId'
    | '/company/leave/$employeeId'
    | '/company/payments/employee'
    | '/company/payments/settlements'
    | '/company/payments/vendor'
    | '/company/payments/vendor-register'
    | '/company/performance-review/$employeeId'
    | '/company/salary/$employeeId'
    | '/company/tracking/$employeeId'
    | '/productivity/chats/$threadId'
    | '/productivity/chats/calls'
    | '/company/approvals'
    | '/company/attendance'
    | '/company/clients'
    | '/company/dashboard'
    | '/company/employees'
    | '/company/holidays'
    | '/company/leave'
    | '/company/payments'
    | '/company/performance-review'
    | '/company/reports'
    | '/company/salary'
    | '/company/tasks'
    | '/company/tracking'
    | '/employee/attendance'
    | '/employee/dashboard'
    | '/employee/expense-ledger'
    | '/employee/handbook'
    | '/employee/leave'
    | '/employee/location'
    | '/employee/profile'
    | '/employee/requests'
    | '/employee/salary'
    | '/employee/tracking'
    | '/owner/overview'
    | '/productivity/chats/'
    | '/productivity/meetings'
    | '/productivity/my-drive'
    | '/productivity/notes'
    | '/productivity/tasks'
    | '/productivity/today'
    | '/company/reports/tally/$report'
    | '/company/reports/aprovals'
    | '/company/reports/attendance'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/start'
    | '/company/announce'
    | '/company/documents'
    | '/company'
    | '/employee'
    | '/integrations'
    | '/owner'
    | '/profile'
    | '/settings'
    | '/company/attendance/$employeeId'
    | '/company/clients/$clientId'
    | '/company/employees/$employeeId'
    | '/company/leave/$employeeId'
    | '/company/payments/employee'
    | '/company/payments/settlements'
    | '/company/payments/vendor'
    | '/company/payments/vendor-register'
    | '/company/performance-review/$employeeId'
    | '/company/salary/$employeeId'
    | '/company/tracking/$employeeId'
    | '/productivity/chats/$threadId'
    | '/productivity/chats/calls'
    | '/company/approvals'
    | '/company/attendance'
    | '/company/clients'
    | '/company/dashboard'
    | '/company/employees'
    | '/company/holidays'
    | '/company/leave'
    | '/company/payments'
    | '/company/performance-review'
    | '/company/reports'
    | '/company/salary'
    | '/company/tasks'
    | '/company/tracking'
    | '/employee/attendance'
    | '/employee/dashboard'
    | '/employee/expense-ledger'
    | '/employee/handbook'
    | '/employee/leave'
    | '/employee/location'
    | '/employee/profile'
    | '/employee/requests'
    | '/employee/salary'
    | '/employee/tracking'
    | '/owner/overview'
    | '/productivity/chats'
    | '/productivity/meetings'
    | '/productivity/my-drive'
    | '/productivity/notes'
    | '/productivity/tasks'
    | '/productivity/today'
    | '/company/reports/tally/$report'
    | '/company/reports/aprovals'
    | '/company/reports/attendance'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/(auth)'
    | '/(auth)/login'
    | '/start/'
    | '/(app)/productivity/chats'
    | '/(app)/company/announce'
    | '/(app)/company/documents'
    | '/(app)/company/'
    | '/(app)/employee/'
    | '/(app)/integrations/'
    | '/(app)/owner/'
    | '/(app)/profile/'
    | '/(app)/settings/'
    | '/(app)/company/attendance/$employeeId'
    | '/(app)/company/clients/$clientId'
    | '/(app)/company/employees/$employeeId'
    | '/(app)/company/leave/$employeeId'
    | '/(app)/company/payments/employee'
    | '/(app)/company/payments/settlements'
    | '/(app)/company/payments/vendor'
    | '/(app)/company/payments/vendor-register'
    | '/(app)/company/performance-review/$employeeId'
    | '/(app)/company/salary/$employeeId'
    | '/(app)/company/tracking/$employeeId'
    | '/(app)/productivity/chats/$threadId'
    | '/(app)/productivity/chats/calls'
    | '/(app)/company/approvals/'
    | '/(app)/company/attendance/'
    | '/(app)/company/clients/'
    | '/(app)/company/dashboard/'
    | '/(app)/company/employees/'
    | '/(app)/company/holidays/'
    | '/(app)/company/leave/'
    | '/(app)/company/payments/'
    | '/(app)/company/performance-review/'
    | '/(app)/company/reports/'
    | '/(app)/company/salary/'
    | '/(app)/company/tasks/'
    | '/(app)/company/tracking/'
    | '/(app)/employee/attendance/'
    | '/(app)/employee/dashboard/'
    | '/(app)/employee/expense-ledger/'
    | '/(app)/employee/handbook/'
    | '/(app)/employee/leave/'
    | '/(app)/employee/location/'
    | '/(app)/employee/profile/'
    | '/(app)/employee/requests/'
    | '/(app)/employee/salary/'
    | '/(app)/employee/tracking/'
    | '/(app)/owner/overview/'
    | '/(app)/productivity/chats/'
    | '/(app)/productivity/meetings/'
    | '/(app)/productivity/my-drive/'
    | '/(app)/productivity/notes/'
    | '/(app)/productivity/tasks/'
    | '/(app)/productivity/today/'
    | '/(app)/company/reports/tally/$report'
    | '/(app)/company/reports/aprovals/'
    | '/(app)/company/reports/attendance/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appLayoutRoute: typeof appLayoutRouteWithChildren
  authLayoutRoute: typeof authLayoutRouteWithChildren
  StartIndexRoute: typeof StartIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start/': {
      id: '/start/'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authLayoutRoute
    }
    '/(app)/settings/': {
      id: '/(app)/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appSettingsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/profile/': {
      id: '/(app)/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof appProfileIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/owner/': {
      id: '/(app)/owner/'
      path: '/owner'
      fullPath: '/owner'
      preLoaderRoute: typeof appOwnerIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/integrations/': {
      id: '/(app)/integrations/'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof appIntegrationsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/': {
      id: '/(app)/employee/'
      path: '/employee'
      fullPath: '/employee'
      preLoaderRoute: typeof appEmployeeIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/': {
      id: '/(app)/company/'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof appCompanyIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/documents': {
      id: '/(app)/company/documents'
      path: '/company/documents'
      fullPath: '/company/documents'
      preLoaderRoute: typeof appCompanyDocumentsRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/announce': {
      id: '/(app)/company/announce'
      path: '/company/announce'
      fullPath: '/company/announce'
      preLoaderRoute: typeof appCompanyAnnounceRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/chats': {
      id: '/(app)/productivity/chats'
      path: '/productivity/chats'
      fullPath: '/productivity/chats'
      preLoaderRoute: typeof appProductivityChatsLayoutRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/today/': {
      id: '/(app)/productivity/today/'
      path: '/productivity/today'
      fullPath: '/productivity/today'
      preLoaderRoute: typeof appProductivityTodayIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/tasks/': {
      id: '/(app)/productivity/tasks/'
      path: '/productivity/tasks'
      fullPath: '/productivity/tasks'
      preLoaderRoute: typeof appProductivityTasksIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/notes/': {
      id: '/(app)/productivity/notes/'
      path: '/productivity/notes'
      fullPath: '/productivity/notes'
      preLoaderRoute: typeof appProductivityNotesIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/my-drive/': {
      id: '/(app)/productivity/my-drive/'
      path: '/productivity/my-drive'
      fullPath: '/productivity/my-drive'
      preLoaderRoute: typeof appProductivityMyDriveIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/meetings/': {
      id: '/(app)/productivity/meetings/'
      path: '/productivity/meetings'
      fullPath: '/productivity/meetings'
      preLoaderRoute: typeof appProductivityMeetingsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/chats/': {
      id: '/(app)/productivity/chats/'
      path: '/'
      fullPath: '/productivity/chats/'
      preLoaderRoute: typeof appProductivityChatsIndexRouteImport
      parentRoute: typeof appProductivityChatsLayoutRoute
    }
    '/(app)/owner/overview/': {
      id: '/(app)/owner/overview/'
      path: '/owner/overview'
      fullPath: '/owner/overview'
      preLoaderRoute: typeof appOwnerOverviewIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/tracking/': {
      id: '/(app)/employee/tracking/'
      path: '/employee/tracking'
      fullPath: '/employee/tracking'
      preLoaderRoute: typeof appEmployeeTrackingIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/salary/': {
      id: '/(app)/employee/salary/'
      path: '/employee/salary'
      fullPath: '/employee/salary'
      preLoaderRoute: typeof appEmployeeSalaryIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/requests/': {
      id: '/(app)/employee/requests/'
      path: '/employee/requests'
      fullPath: '/employee/requests'
      preLoaderRoute: typeof appEmployeeRequestsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/profile/': {
      id: '/(app)/employee/profile/'
      path: '/employee/profile'
      fullPath: '/employee/profile'
      preLoaderRoute: typeof appEmployeeProfileIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/location/': {
      id: '/(app)/employee/location/'
      path: '/employee/location'
      fullPath: '/employee/location'
      preLoaderRoute: typeof appEmployeeLocationIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/leave/': {
      id: '/(app)/employee/leave/'
      path: '/employee/leave'
      fullPath: '/employee/leave'
      preLoaderRoute: typeof appEmployeeLeaveIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/handbook/': {
      id: '/(app)/employee/handbook/'
      path: '/employee/handbook'
      fullPath: '/employee/handbook'
      preLoaderRoute: typeof appEmployeeHandbookIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/expense-ledger/': {
      id: '/(app)/employee/expense-ledger/'
      path: '/employee/expense-ledger'
      fullPath: '/employee/expense-ledger'
      preLoaderRoute: typeof appEmployeeExpenseLedgerIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/dashboard/': {
      id: '/(app)/employee/dashboard/'
      path: '/employee/dashboard'
      fullPath: '/employee/dashboard'
      preLoaderRoute: typeof appEmployeeDashboardIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/employee/attendance/': {
      id: '/(app)/employee/attendance/'
      path: '/employee/attendance'
      fullPath: '/employee/attendance'
      preLoaderRoute: typeof appEmployeeAttendanceIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/tracking/': {
      id: '/(app)/company/tracking/'
      path: '/company/tracking'
      fullPath: '/company/tracking'
      preLoaderRoute: typeof appCompanyTrackingIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/tasks/': {
      id: '/(app)/company/tasks/'
      path: '/company/tasks'
      fullPath: '/company/tasks'
      preLoaderRoute: typeof appCompanyTasksIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/salary/': {
      id: '/(app)/company/salary/'
      path: '/company/salary'
      fullPath: '/company/salary'
      preLoaderRoute: typeof appCompanySalaryIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/reports/': {
      id: '/(app)/company/reports/'
      path: '/company/reports'
      fullPath: '/company/reports'
      preLoaderRoute: typeof appCompanyReportsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/performance-review/': {
      id: '/(app)/company/performance-review/'
      path: '/company/performance-review'
      fullPath: '/company/performance-review'
      preLoaderRoute: typeof appCompanyPerformanceReviewIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/payments/': {
      id: '/(app)/company/payments/'
      path: '/company/payments'
      fullPath: '/company/payments'
      preLoaderRoute: typeof appCompanyPaymentsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/leave/': {
      id: '/(app)/company/leave/'
      path: '/company/leave'
      fullPath: '/company/leave'
      preLoaderRoute: typeof appCompanyLeaveIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/holidays/': {
      id: '/(app)/company/holidays/'
      path: '/company/holidays'
      fullPath: '/company/holidays'
      preLoaderRoute: typeof appCompanyHolidaysIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/employees/': {
      id: '/(app)/company/employees/'
      path: '/company/employees'
      fullPath: '/company/employees'
      preLoaderRoute: typeof appCompanyEmployeesIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/dashboard/': {
      id: '/(app)/company/dashboard/'
      path: '/company/dashboard'
      fullPath: '/company/dashboard'
      preLoaderRoute: typeof appCompanyDashboardIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/clients/': {
      id: '/(app)/company/clients/'
      path: '/company/clients'
      fullPath: '/company/clients'
      preLoaderRoute: typeof appCompanyClientsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/attendance/': {
      id: '/(app)/company/attendance/'
      path: '/company/attendance'
      fullPath: '/company/attendance'
      preLoaderRoute: typeof appCompanyAttendanceIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/approvals/': {
      id: '/(app)/company/approvals/'
      path: '/company/approvals'
      fullPath: '/company/approvals'
      preLoaderRoute: typeof appCompanyApprovalsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/productivity/chats/calls': {
      id: '/(app)/productivity/chats/calls'
      path: '/calls'
      fullPath: '/productivity/chats/calls'
      preLoaderRoute: typeof appProductivityChatsCallsRouteImport
      parentRoute: typeof appProductivityChatsLayoutRoute
    }
    '/(app)/productivity/chats/$threadId': {
      id: '/(app)/productivity/chats/$threadId'
      path: '/$threadId'
      fullPath: '/productivity/chats/$threadId'
      preLoaderRoute: typeof appProductivityChatsThreadIdRouteImport
      parentRoute: typeof appProductivityChatsLayoutRoute
    }
    '/(app)/company/tracking/$employeeId': {
      id: '/(app)/company/tracking/$employeeId'
      path: '/company/tracking/$employeeId'
      fullPath: '/company/tracking/$employeeId'
      preLoaderRoute: typeof appCompanyTrackingEmployeeIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/salary/$employeeId': {
      id: '/(app)/company/salary/$employeeId'
      path: '/company/salary/$employeeId'
      fullPath: '/company/salary/$employeeId'
      preLoaderRoute: typeof appCompanySalaryEmployeeIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/performance-review/$employeeId': {
      id: '/(app)/company/performance-review/$employeeId'
      path: '/company/performance-review/$employeeId'
      fullPath: '/company/performance-review/$employeeId'
      preLoaderRoute: typeof appCompanyPerformanceReviewEmployeeIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/payments/vendor-register': {
      id: '/(app)/company/payments/vendor-register'
      path: '/company/payments/vendor-register'
      fullPath: '/company/payments/vendor-register'
      preLoaderRoute: typeof appCompanyPaymentsVendorRegisterRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/payments/vendor': {
      id: '/(app)/company/payments/vendor'
      path: '/company/payments/vendor'
      fullPath: '/company/payments/vendor'
      preLoaderRoute: typeof appCompanyPaymentsVendorRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/payments/settlements': {
      id: '/(app)/company/payments/settlements'
      path: '/company/payments/settlements'
      fullPath: '/company/payments/settlements'
      preLoaderRoute: typeof appCompanyPaymentsSettlementsRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/payments/employee': {
      id: '/(app)/company/payments/employee'
      path: '/company/payments/employee'
      fullPath: '/company/payments/employee'
      preLoaderRoute: typeof appCompanyPaymentsEmployeeRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/leave/$employeeId': {
      id: '/(app)/company/leave/$employeeId'
      path: '/company/leave/$employeeId'
      fullPath: '/company/leave/$employeeId'
      preLoaderRoute: typeof appCompanyLeaveEmployeeIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/employees/$employeeId': {
      id: '/(app)/company/employees/$employeeId'
      path: '/company/employees/$employeeId'
      fullPath: '/company/employees/$employeeId'
      preLoaderRoute: typeof appCompanyEmployeesEmployeeIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/clients/$clientId': {
      id: '/(app)/company/clients/$clientId'
      path: '/company/clients/$clientId'
      fullPath: '/company/clients/$clientId'
      preLoaderRoute: typeof appCompanyClientsClientIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/attendance/$employeeId': {
      id: '/(app)/company/attendance/$employeeId'
      path: '/company/attendance/$employeeId'
      fullPath: '/company/attendance/$employeeId'
      preLoaderRoute: typeof appCompanyAttendanceEmployeeIdRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/reports/attendance/': {
      id: '/(app)/company/reports/attendance/'
      path: '/company/reports/attendance'
      fullPath: '/company/reports/attendance'
      preLoaderRoute: typeof appCompanyReportsAttendanceIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/reports/aprovals/': {
      id: '/(app)/company/reports/aprovals/'
      path: '/company/reports/aprovals'
      fullPath: '/company/reports/aprovals'
      preLoaderRoute: typeof appCompanyReportsAprovalsIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/(app)/company/reports/tally/$report': {
      id: '/(app)/company/reports/tally/$report'
      path: '/company/reports/tally/$report'
      fullPath: '/company/reports/tally/$report'
      preLoaderRoute: typeof appCompanyReportsTallyReportRouteImport
      parentRoute: typeof appLayoutRoute
    }
  }
}

interface appProductivityChatsLayoutRouteChildren {
  appProductivityChatsThreadIdRoute: typeof appProductivityChatsThreadIdRoute
  appProductivityChatsCallsRoute: typeof appProductivityChatsCallsRoute
  appProductivityChatsIndexRoute: typeof appProductivityChatsIndexRoute
}

const appProductivityChatsLayoutRouteChildren: appProductivityChatsLayoutRouteChildren =
  {
    appProductivityChatsThreadIdRoute: appProductivityChatsThreadIdRoute,
    appProductivityChatsCallsRoute: appProductivityChatsCallsRoute,
    appProductivityChatsIndexRoute: appProductivityChatsIndexRoute,
  }

const appProductivityChatsLayoutRouteWithChildren =
  appProductivityChatsLayoutRoute._addFileChildren(
    appProductivityChatsLayoutRouteChildren,
  )

interface appLayoutRouteChildren {
  appProductivityChatsLayoutRoute: typeof appProductivityChatsLayoutRouteWithChildren
  appCompanyAnnounceRoute: typeof appCompanyAnnounceRoute
  appCompanyDocumentsRoute: typeof appCompanyDocumentsRoute
  appCompanyIndexRoute: typeof appCompanyIndexRoute
  appEmployeeIndexRoute: typeof appEmployeeIndexRoute
  appIntegrationsIndexRoute: typeof appIntegrationsIndexRoute
  appOwnerIndexRoute: typeof appOwnerIndexRoute
  appProfileIndexRoute: typeof appProfileIndexRoute
  appSettingsIndexRoute: typeof appSettingsIndexRoute
  appCompanyAttendanceEmployeeIdRoute: typeof appCompanyAttendanceEmployeeIdRoute
  appCompanyClientsClientIdRoute: typeof appCompanyClientsClientIdRoute
  appCompanyEmployeesEmployeeIdRoute: typeof appCompanyEmployeesEmployeeIdRoute
  appCompanyLeaveEmployeeIdRoute: typeof appCompanyLeaveEmployeeIdRoute
  appCompanyPaymentsEmployeeRoute: typeof appCompanyPaymentsEmployeeRoute
  appCompanyPaymentsSettlementsRoute: typeof appCompanyPaymentsSettlementsRoute
  appCompanyPaymentsVendorRoute: typeof appCompanyPaymentsVendorRoute
  appCompanyPaymentsVendorRegisterRoute: typeof appCompanyPaymentsVendorRegisterRoute
  appCompanyPerformanceReviewEmployeeIdRoute: typeof appCompanyPerformanceReviewEmployeeIdRoute
  appCompanySalaryEmployeeIdRoute: typeof appCompanySalaryEmployeeIdRoute
  appCompanyTrackingEmployeeIdRoute: typeof appCompanyTrackingEmployeeIdRoute
  appCompanyApprovalsIndexRoute: typeof appCompanyApprovalsIndexRoute
  appCompanyAttendanceIndexRoute: typeof appCompanyAttendanceIndexRoute
  appCompanyClientsIndexRoute: typeof appCompanyClientsIndexRoute
  appCompanyDashboardIndexRoute: typeof appCompanyDashboardIndexRoute
  appCompanyEmployeesIndexRoute: typeof appCompanyEmployeesIndexRoute
  appCompanyHolidaysIndexRoute: typeof appCompanyHolidaysIndexRoute
  appCompanyLeaveIndexRoute: typeof appCompanyLeaveIndexRoute
  appCompanyPaymentsIndexRoute: typeof appCompanyPaymentsIndexRoute
  appCompanyPerformanceReviewIndexRoute: typeof appCompanyPerformanceReviewIndexRoute
  appCompanyReportsIndexRoute: typeof appCompanyReportsIndexRoute
  appCompanySalaryIndexRoute: typeof appCompanySalaryIndexRoute
  appCompanyTasksIndexRoute: typeof appCompanyTasksIndexRoute
  appCompanyTrackingIndexRoute: typeof appCompanyTrackingIndexRoute
  appEmployeeAttendanceIndexRoute: typeof appEmployeeAttendanceIndexRoute
  appEmployeeDashboardIndexRoute: typeof appEmployeeDashboardIndexRoute
  appEmployeeExpenseLedgerIndexRoute: typeof appEmployeeExpenseLedgerIndexRoute
  appEmployeeHandbookIndexRoute: typeof appEmployeeHandbookIndexRoute
  appEmployeeLeaveIndexRoute: typeof appEmployeeLeaveIndexRoute
  appEmployeeLocationIndexRoute: typeof appEmployeeLocationIndexRoute
  appEmployeeProfileIndexRoute: typeof appEmployeeProfileIndexRoute
  appEmployeeRequestsIndexRoute: typeof appEmployeeRequestsIndexRoute
  appEmployeeSalaryIndexRoute: typeof appEmployeeSalaryIndexRoute
  appEmployeeTrackingIndexRoute: typeof appEmployeeTrackingIndexRoute
  appOwnerOverviewIndexRoute: typeof appOwnerOverviewIndexRoute
  appProductivityMeetingsIndexRoute: typeof appProductivityMeetingsIndexRoute
  appProductivityMyDriveIndexRoute: typeof appProductivityMyDriveIndexRoute
  appProductivityNotesIndexRoute: typeof appProductivityNotesIndexRoute
  appProductivityTasksIndexRoute: typeof appProductivityTasksIndexRoute
  appProductivityTodayIndexRoute: typeof appProductivityTodayIndexRoute
  appCompanyReportsTallyReportRoute: typeof appCompanyReportsTallyReportRoute
  appCompanyReportsAprovalsIndexRoute: typeof appCompanyReportsAprovalsIndexRoute
  appCompanyReportsAttendanceIndexRoute: typeof appCompanyReportsAttendanceIndexRoute
}

const appLayoutRouteChildren: appLayoutRouteChildren = {
  appProductivityChatsLayoutRoute: appProductivityChatsLayoutRouteWithChildren,
  appCompanyAnnounceRoute: appCompanyAnnounceRoute,
  appCompanyDocumentsRoute: appCompanyDocumentsRoute,
  appCompanyIndexRoute: appCompanyIndexRoute,
  appEmployeeIndexRoute: appEmployeeIndexRoute,
  appIntegrationsIndexRoute: appIntegrationsIndexRoute,
  appOwnerIndexRoute: appOwnerIndexRoute,
  appProfileIndexRoute: appProfileIndexRoute,
  appSettingsIndexRoute: appSettingsIndexRoute,
  appCompanyAttendanceEmployeeIdRoute: appCompanyAttendanceEmployeeIdRoute,
  appCompanyClientsClientIdRoute: appCompanyClientsClientIdRoute,
  appCompanyEmployeesEmployeeIdRoute: appCompanyEmployeesEmployeeIdRoute,
  appCompanyLeaveEmployeeIdRoute: appCompanyLeaveEmployeeIdRoute,
  appCompanyPaymentsEmployeeRoute: appCompanyPaymentsEmployeeRoute,
  appCompanyPaymentsSettlementsRoute: appCompanyPaymentsSettlementsRoute,
  appCompanyPaymentsVendorRoute: appCompanyPaymentsVendorRoute,
  appCompanyPaymentsVendorRegisterRoute: appCompanyPaymentsVendorRegisterRoute,
  appCompanyPerformanceReviewEmployeeIdRoute:
    appCompanyPerformanceReviewEmployeeIdRoute,
  appCompanySalaryEmployeeIdRoute: appCompanySalaryEmployeeIdRoute,
  appCompanyTrackingEmployeeIdRoute: appCompanyTrackingEmployeeIdRoute,
  appCompanyApprovalsIndexRoute: appCompanyApprovalsIndexRoute,
  appCompanyAttendanceIndexRoute: appCompanyAttendanceIndexRoute,
  appCompanyClientsIndexRoute: appCompanyClientsIndexRoute,
  appCompanyDashboardIndexRoute: appCompanyDashboardIndexRoute,
  appCompanyEmployeesIndexRoute: appCompanyEmployeesIndexRoute,
  appCompanyHolidaysIndexRoute: appCompanyHolidaysIndexRoute,
  appCompanyLeaveIndexRoute: appCompanyLeaveIndexRoute,
  appCompanyPaymentsIndexRoute: appCompanyPaymentsIndexRoute,
  appCompanyPerformanceReviewIndexRoute: appCompanyPerformanceReviewIndexRoute,
  appCompanyReportsIndexRoute: appCompanyReportsIndexRoute,
  appCompanySalaryIndexRoute: appCompanySalaryIndexRoute,
  appCompanyTasksIndexRoute: appCompanyTasksIndexRoute,
  appCompanyTrackingIndexRoute: appCompanyTrackingIndexRoute,
  appEmployeeAttendanceIndexRoute: appEmployeeAttendanceIndexRoute,
  appEmployeeDashboardIndexRoute: appEmployeeDashboardIndexRoute,
  appEmployeeExpenseLedgerIndexRoute: appEmployeeExpenseLedgerIndexRoute,
  appEmployeeHandbookIndexRoute: appEmployeeHandbookIndexRoute,
  appEmployeeLeaveIndexRoute: appEmployeeLeaveIndexRoute,
  appEmployeeLocationIndexRoute: appEmployeeLocationIndexRoute,
  appEmployeeProfileIndexRoute: appEmployeeProfileIndexRoute,
  appEmployeeRequestsIndexRoute: appEmployeeRequestsIndexRoute,
  appEmployeeSalaryIndexRoute: appEmployeeSalaryIndexRoute,
  appEmployeeTrackingIndexRoute: appEmployeeTrackingIndexRoute,
  appOwnerOverviewIndexRoute: appOwnerOverviewIndexRoute,
  appProductivityMeetingsIndexRoute: appProductivityMeetingsIndexRoute,
  appProductivityMyDriveIndexRoute: appProductivityMyDriveIndexRoute,
  appProductivityNotesIndexRoute: appProductivityNotesIndexRoute,
  appProductivityTasksIndexRoute: appProductivityTasksIndexRoute,
  appProductivityTodayIndexRoute: appProductivityTodayIndexRoute,
  appCompanyReportsTallyReportRoute: appCompanyReportsTallyReportRoute,
  appCompanyReportsAprovalsIndexRoute: appCompanyReportsAprovalsIndexRoute,
  appCompanyReportsAttendanceIndexRoute: appCompanyReportsAttendanceIndexRoute,
}

const appLayoutRouteWithChildren = appLayoutRoute._addFileChildren(
  appLayoutRouteChildren,
)

interface authLayoutRouteChildren {
  authLoginRoute: typeof authLoginRoute
}

const authLayoutRouteChildren: authLayoutRouteChildren = {
  authLoginRoute: authLoginRoute,
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(
  authLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appLayoutRoute: appLayoutRouteWithChildren,
  authLayoutRoute: authLayoutRouteWithChildren,
  StartIndexRoute: StartIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
